<template>
    <div id="manageClass">
        <div class="allBodyDiv">
            <div style="margin-top: 15px">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/manageclass' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: backUrl }">{{$route.query.userName}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{pathName}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>

            <el-row class="manageClassBody" :gutter="20">
                <el-col :span="24" class="leftMember">
                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <i class="blueI" style="left: 10px"></i>


                            <div style="display:inline-block">
                                <span class="cardHeader">{{$route.query.userName}}-{{pathName}}</span>
                            </div>
                            <div class="fr" style="margin-right: 41%">
                                <el-radio-group v-model="radio3" @change="getData()">
                                    <el-radio-button :label="1">综合统计</el-radio-button>
                                    <el-radio-button :label="2">单次统计</el-radio-button>
                                </el-radio-group>
                            </div>
                        </div>
                        <div style="margin-top:30px; ">
                            <div style="position:relative">
                                <div>
                                    <div v-if="radio3==1">
                                        <div style="position:absolute">
                                            <span><img src="/static/images/exam/quxian.png" alt="" align="top"></span>
                                            分数曲线
                                        </div>
                                        <ve-line  id="canvas" :data="chartData" :settings="chartSettings"></ve-line>
                                    </div>

                                    <div v-else style="margin-bottom: 20px;">
                                        <div>
                                            <el-row style="padding-bottom:10px;border-bottom:1px solid #ebedf3">
                                                <div
                                                        v-for="i in listData"
                                                        :key="i.id"
                                                        :class="{testCard:true, activeTest:i.active}"
                                                        style="margin-bottom: 20px;"
                                                        @click="getSingInfo(i.exerciseId)">
                                                    <span>{{i.score}}分</span>
                                                    <span>{{i.addtime}}</span>
                                                </div>
                                            </el-row>
                                        </div>


                                        <el-row style="margin-top:35px;">
                                            <div style="height:25px;line-height:16px;margin-bottom: 15px;">
                                                <span><img src="/static/images/exam/dianpin.png" alt="" align="top"></span>
                                                实验点评
                                            </div>
                                            <div class="testDetails">
                                                <div v-if="singData&&singData.comments" style="color:#f76252">在操作顺序方面，需要注意以下几点</div>

                                                <div v-for="(index,i) in singData.comments" style="padding-left:10px;">
                                                    {{i+1}}.&nbsp;{{index}}
                                                </div>

                                                <div v-if="singData&&singData.step_comment" style="color:#f76252">在操作及数据处理上，需要注意以下几点</div>
                                                <div v-for="(index,i) in singData.step_comment" style="padding-left:10px;">
                                                    {{i+1}}.&nbsp;{{index}}
                                                </div>
                                            </div>
                                        </el-row>
                                    </div>
                                </div>

                                <div style="height:25px;line-height:25px;margin-bottom: 15px;">
                                    <span><img src="/static/images/exam/defen.png" alt="" align="top"></span>
                                    得分细则
                                </div>

                                <div v-if="radio3==1" >
                                    <div class="tableDataHeader">
                                        <div style="width: 439px">实验步骤</div>
                                        <div style="width: 437px">实验操作</div>
                                        <div style="width: 119px">错误次数</div>
                                        <div style="width: 141px;border-right:none">错误类型</div>
                                    </div>
                                    <div class="tableDataBody">
                                        <div v-for="i in erbibuchu" :key="i.step_name">
                                            <div>
                                                <div :style="{width:'439px',height:i.nameHeight+'px',lineHeight:i.nameHeight+'px',overflow:'hidden'}" class="dataTitle">{{i.step_name}}</div>
                                                <div class="dataBody" v-for="a in i.itemStep">
                                                    <div :style="{width:'437px',height:a.stepHeight+'px',lineHeight:a.stepHeight+'px',overflow:'hidden'}">{{a.step_name}}</div>
                                                    <div :style="{width:'119px',height:a.stepHeight+'px',lineHeight:a.stepHeight+'px',overflow:'hidden',color:a.error_num<=0?'':'red'}">{{a.noNum}}</div>
                                                    <div class="errorInfo" style="width: 119px;">
                                                        <div v-for="c in a.errList" style="height:100px;line-height:100px">
                                                            <div style="width:140px;text-align:center;height:100px;line-height:100px">
                                                            <span v-if="c.name">
                                                                <img v-if="c.name.indexOf('数据')!=-1" src="/static/images/exam/data.png" width="14px" alt="">
                                                            <img v-else-if="c.name.indexOf('操作')!=-1" src="/static/images/exam/operate.png" width="14px" alt="">
                                                            <img v-else-if="c.name.indexOf('顺序')!=-1" src="/static/images/exam/order.png" width="14px" alt="">
                                                                <span v-else></span>
                                                                {{c.name}}（{{c.num}}）
                                                            </span>
                                                                <span v-else>
                                                                    
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div v-else >
                                    <div class="tableDataHeader">
                                        <div style="width: 439px">实验步骤</div>
                                        <div style="width: 437px">实验操作</div>
                                        <div style="width: 119px">评分</div>
                                        <div style="width: 159px;border-right:none">错误类型</div>
                                    </div>
                                    <div class="tableDataBody">
                                        <div v-for="i in singData.steps">
                                            <div>
                                                <div :style="{width:'439px',height:i.nameHeight+'px',lineHeight:i.nameHeight+'px',overflow:'hidden'}" class="dataTitle">{{i.step_name}}</div>
                                                <div class="dataBody" v-for="a in i.itemStep">
                                                    <div :style="{width:'437px',height:a.stepHeight+'px',lineHeight:a.stepHeight+'px',overflow:'hidden'}">{{a.step_name}}</div>
                                                    <div :style="{width:'119px',height:a.stepHeight+'px',lineHeight:a.stepHeight+'px',overflow:'hidden',color:a.score<=6&&a.score?'red':''}">{{a.score?a.score:'暂无评分'}}</div>
                                                    <div class="errorInfo" style="width: 119px">
                                                        <div style="width:140px;text-align:center">
                                                            <span v-if="a.error  ">
                                                                <img v-if="a.error.indexOf('数据')!=-1" src="/static/images/exam/data.png" width="14px" alt="">
                                                            <img v-else-if="a.error.indexOf('操作')!=-1" src="/static/images/exam/operate.png" width="14px" alt="">
                                                            <img v-else-if="a.error.indexOf('顺序')!=-1" src="/static/images/exam/order.png" width="14px" alt="">
                                                                <span v-else></span>
                                                            </span>
                                                            <span v-else></span>
                                                            {{a.error}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
    import{
      getStudentExamInfo ,
        gettestrecord,
        getclassexaminfo,
        getuserexamcount,
        getuserexam
    }from'./../../api/exam_api'
    export default {
        data() {
            return{
                pathName:'',
                tableData2:[],
                backUrl:'',
                currentPage4:1,
                radio3:1,
                chartData:{
                    columns: ['counttime', 'countnum'],
                    rows: []
                },
                chartSettings : {
                    labelMap: {
                        countnum: '得分'
                    }
                },
                timeValue:[],
                data:{},
                testName:'',
                listData:[],
                testId:'',
                stepData:[],
                active:false,
                erbibuchu:[],
              singData:{},//单词考试数据
            }
        },
        methods:{
            pageSizeChange(){},
            pageChange(){},
            objectSpanMethod({ row, column, rowIndex, columnIndex }) {
                if (columnIndex === 0) {
                    if (rowIndex %3 === 0) {
                        return {
                            rowspan: 3,
                            colspan: 1
                        };
                    } else {
                        return {
                            rowspan: 0,
                            colspan: 0
                        };
                    }
                }
            },
            getData($typr){
                this.stepData=[];
                this.erbibuchu=[];
                let data2={
                    userId:this.$route.query.plan,
                    experimentId:this.$route.query.type,
                };
                getuserexam(data2).then((res)=>{
                    this.chartData.rows=[];
                    if(res.code==200 || res.code == 0){
                        res.data.forEach(function(index,i){
                          let obj={
                            counttime:index.addtime,
                            countnum:index.score
                          };
                          this.chartData.rows.push(obj);
                        }.bind(this));
                        this.listData=res.data;
                        this.getSingInfo(res.data[0].exerciseId);
                        if($typr){
                            this.testId=$typr
                        }else{
                            if(this.radio3==2){
                                this.testId=res.data[0].userid;
                                res.data[0].active=true;
                            }
                        }

                            this.data=[];
                        }
                });
            },
          getTable(){
            let data={
              userId:this.$route.query.plan,
              experimentId:this.$route.query.type
            };
            getuserexamcount(data).then((res)=>{
              let _height=0;
              let that=this;
              if(res.data){
                res.data.forEach(function(index,i){
                  _height=0;
                  index.itemStep.forEach(function(index,i){
                    if(that.radio3==1){
                      index.stepHeight=50 * (index.errList.length + 1);
                    }else{
                      index.stepHeight=50;
                    }
                    _height+=index.stepHeight +  0.5;
                  });
                  index.nameHeight=_height;
                });
                this.data.commentsList=res.data.comments;
                this.data.stepList=res.data.step;
                this.erbibuchu=res.data
              }
              if(this.data.name){
                this.testName=this.data.name;
              }
            });
          },
          getSingInfo($typr){
            this.listData.forEach(function(index,i) {
              if (index.examinationId == $typr) {
                index.active = true;
              } else {
                index.active = false;
              }
            });
              let data={
                user_id:this.$route.query.plan,
                exercise_id:$typr
              };
            getStudentExamInfo(data).then((res)=>{
              if(res.code == 200 || res.code == 0){
                let _height=0,that=this;
                res.data.steps.forEach((index,i)=>{
                  _height=0;
                  index.itemStep.forEach(function(index,i){
                    if(that.radio3==1){
                      index.stepHeight=50;
                    }else{
                      index.stepHeight=50;
                    }
                    _height+=index.stepHeight +  0.5;
                  });
                  index.nameHeight=_height;
                });
                this.singData = res.data;
              }
            });
          }
        },
        mounted(){
            this.getData();
            this.getTable();
            this.pathName = this.$route.query.examName;
            if(this.$route.query.url){
                this.backUrl='/memberdetails'+this.$route.query.url
            }
        }
    }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/assets/js/pages/exam/ClassUserDetails.vue